export enum RelatedEntityType {
	KEY_PHRASE = 'KEY_PHRASE',
	TOPIC = 'TOPIC',
	USER = 'USER',
	CONFLUENCE_DOCUMENT = 'CONFLUENCE_DOCUMENT',
	CONFLUENCE_PAGE = 'CONFLUENCE_PAGE',
	CONFLUENCE_BLOGPOST = 'CONFLUENCE_BLOGPOST',
}
